/** @format */

import * as actions from '../actions/downlink';

const defaultState = {
  isLoading: false,
  error: false,
};

export const downlink = (state = defaultState, action) => {
  switch (action.type) {
    case actions.POST_DOWNLINK_REQUEST:
      return {
        isLoading: true,
        error: false,
      };
    case actions.POST_DOWNLINK_SUCCESS:
      return {
        ...action.payload,
        isLoading: false,
        error: false,
      };
    case actions.POST_DOWNLINK_FAILURE:
      return {
        ...action.payload,
        isLoading: false,
        error: true,
      };

    default:
      return state;
  }
};
